export default {
    tiposDownload: [{label: 'Original', valor: 'ORIGINAL'}, {label:'Assinado', valor:'ASSINADO'}, {label:'Impressão', valor:'IMPRESSAO'}]
}
